module.exports = __webpack_public_path__ + "img/diagram_fair.0233d954.svg";